import { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const RichTextStyle = css`
  font-family: 'Open Sans', OpenSans, Raleway !important;
  text-align: left !important;
  ol, ul {
    padding-left: 20px !important;
    list-style: revert !important;
    li {
      margin: 0.5rem 0.5rem 0.5rem 1rem !important;
      line-height: 1.6 !important;
      font-size: 20px !important;
      ${breakpoint('mobile', 'desktop')`
        font-size: 18px !important;
      `}
    }
  }

  img {
    ${breakpoint('mobile', 'desktop')`
      width: 100%;
      height: auto;
    `}
  }

  span {
    font-family: 'Open Sans', OpenSans, Raleway !important;
    line-height: 1.6 !important;
    font-size: 20px !important;
    text-align: left !important;
  }
  table,
  th,
  td {
    border: 1px solid black;
    ${breakpoint('desktop')`
      padding: 10px;
    `}
    
    div{
      ${breakpoint('mobile', 'desktop')`
        font-size: 14px !important;
      `}
    }

    p{
      ${breakpoint('mobile', 'desktop')`
        font-size: 14px !important;
      `}
    }

    ${breakpoint('mobile', 'desktop')`
      padding: 5px;
      word-wrap: break-word;
    `}
  }

  table {
   margin: 0 auto;
   margin-top: 20px;
   margin-bottom: 20px;

   ${breakpoint('mobile', 'desktop')`
      table-layout: fixed;
      width: 100% !important;
      font-size: 14px !important;
    `}
  }

  h1 {
    font-size: 42px !important;
    font-weight: 700 !important;
    span {
      font-size: 42px !important;
      font-weight: 700 !important;
    }
  }

  div {
    font-family: 'Open Sans', OpenSans, Raleway !important;
    font-size: 20px !important;
    line-height: 1.6 !important;
    text-align: left !important;
  }

  h2,
  h3,
  h4 {
    font-size: 24px !important;
    font-weight: 700 !important;
    span {
      font-size: 24px !important;
      font-weight: 700 !important;
    }
  }

  ul {
    font-family: 'Open Sans', OpenSans, Raleway !important;
    list-style: unset;
    font-size: 20px !important;
    padding-left: 20px !important;
  }

  p {
    font-family: 'Open Sans', OpenSans, Raleway !important;
    font-size: 20px !important;
    line-height: 1.6 !important;
    text-align: left !important;
  }
  strong {
    font-weight: 700 !important;
    font-family: 'Open Sans', OpenSans, Raleway !important;
  }
  em {
    font-family: 'Open Sans', OpenSans, Raleway !important;
    font-style: italic;
  }

  ${breakpoint('mobile', 'desktop')`
     font-size: 18px !important;
     line-height: 1.6;
     .flex-column-mobile {
     flex-direction: column-reverse;
     & > div {
      width: 100% !important;
      padding: 1rem 0px !important;
    }
  }
  div{
    font-size: 18px !important;
  }
  p{
    font-size: 18px !important;
  }

  h1 {
    font-size: 24px !important;
    font-weight: 700 !important;
    span {
      font-size: 24px !important;
      font-weight: 700 !important;
    }
  }

  h2,h3,h4 {
    font-weight: 700 !important;
    span {
      font-size: 20px !important;
      font-weight: 700 !important;
    }
    font-size: 20px !important;
  }
  span{
    font-size: 18px !important;
  }

      
    `}
  ${breakpoint('tablet', 'desktop')`
    div{
      font-size: 18px !important;
    }
    p{
      font-size: 18px !important;
    }
    `}
  
  h2,
  h1,
  h3,
  h4 {
    font-family: 'Open Sans', OpenSans, Raleway !important;
    margin: 1rem 0px;
  }
`;
